// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"8228d617","453":"39598a29","488":"9604e433","707":"f322c7f9"}[chunkId] + ".chunk.js";
};